/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Spin,
  Tabs,
  Modal,
  DatePicker,
  Card,
  TreeSelect,
} from 'antd';
import {
  CheckCircleOutlined,
} from '@ant-design/icons';
import Select from 'components/Select';
import { onError, onSuccess } from 'utils/handlers';
import {
  getCuentasContables,
  getEstadosGlobales,
} from 'api/catalogos';
import Table from 'components/Table';
import { ESTATUS_ACTIVO, ESTATUS_AUTORIZADO, ESTATUS_INACTIVO } from 'utils/constants';
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDelete from 'components/ModalDelete';
import FormSubmitControls from 'components/FormSubmitControls';
import {
  autorizarIPEJALtasa,
  deleteIPEJALtasa,
  getIPEJALtasa, getIPEJALtasas, patchIPEJALtasa, postIPEJALtasa,
} from 'api/nominas/IPEJALtasas';
import { formatReceived, formatReceivedValues } from 'utils/formatValues';
import moment from 'moment/moment';
import { getConfiguracionIncidencias } from 'api/nominas/incidencias/configuracionIncidencias';
import { getEvaluacionesAsistencia } from 'api/catalogos/TiposDeEvaluacionAsistencia';
import PercentageInput from 'components/PercentageInput';
import percentFormatter from 'utils/percentFormatter';
import { FLOAT_NUMER_PATTERN } from 'utils/patterns';
import { getModelPermission } from 'utils/permission';
import { getCatalogosDeCuentasContablesPasivo } from 'api/catalogos/CatalogoDeCuentasContablesPasivo';
import RegistroPresupuestalIPEJAL, { registroPresupuestalIPEJALPermission } from './RegistroPresupuestalIPEJAL';
import CuentaContableIPEJAL from './CuentaContableIPEJAL';

/** cambiar */
export const tasasIPEJALPermission = {
  permissionModel: 'cargadereporte',
  catalogsModels: [],
  tabsModels: [],
};

const getPermissionRegistro = getModelPermission(
  registroPresupuestalIPEJALPermission.permissionModel,
  registroPresupuestalIPEJALPermission.catalogsModels,
  registroPresupuestalIPEJALPermission.tabsModels,
  false,
);

export const onErrorFields = (
  err,
  setLoading = null,
  formsInstances = [],
  setCurrentTabKey,
) => {
  if (typeof setLoading === 'function') {
    setLoading(false);
  }
  const errorKeys = err.errorFields.map((e) => e.name[0]);
  const formWithErrors = formsInstances.find(
    (obj) => obj.tabFields.some(
      (val) => errorKeys.includes(val),
    ),
  );
  if (formWithErrors) {
    setTimeout(() => {
      if (typeof setCurrentTabKey === 'function') {
        setCurrentTabKey(formWithErrors.tabKey);
      }
    });
  }
};

const TasasIPEJAL = ({ permission }) => {
  const [form] = Form.useForm();
  const [isAdding, setAdding] = useState(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);
  const [disableFields, setDisableFields] = useState(false);
  const [catalogoDecuentasContablesPasivo, setCatalogoDeCuentasContablesPasivo] = useState([]);
  const [tipoCuenta, setTipoCuenta] = useState('general');
  const [cuentasContables, setCuentasContables] = useState([]);

  const formInstances = [
    form,
  ];

  const mapToTreeData = (nodes) => nodes.map((node) => {
    const isLeaf = !node.children || node.children.length === 0;

    return {
      title: `${node.clave_visible || node.clave} - ${node.nombre}`,
      value: node.id,
      key: node.id,
      disabled: !isLeaf, //  Deshabilita si no es hoja
      children: node.children ? mapToTreeData(node.children) : undefined,
    };
  });
  const removeEmptyChildren = (node) => {
    if (!node.children || node.children.length === 0) {
      return { ...node, children: undefined };
    }

    return {
      ...node,
      children: node.children.map(removeEmptyChildren),
    };
  };
  const normalize = (_data) => {
    const nodeMap = new Map();

    _data.forEach((node) => {
      nodeMap.set(node.id, {
        ...node,
        children: [],
        key: `${node.id}`, // clave única para antd Table
      });
    });
    const roots = [];
    _data.forEach((node) => {
      const currentNode = nodeMap.get(node.id);
      if (node.cuenta_padre) {
        const parent = nodeMap.get(node.cuenta_padre);
        if (parent) {
          parent.children.push(currentNode);
        }
      } else {
        roots.push(currentNode);
      }
    });

    return roots.map(removeEmptyChildren);
  };

  const fetchData = async () => {
    setLoading(true);
    const _data = await getIPEJALtasas();
    setData(formatReceived(_data));
    setLoading(false);
  };
  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [
        _catalogoDeCuentasContablesPasivo,
        _cuentasContables,
        _data,
        _estados,
      ] = await Promise.all([
        getCatalogosDeCuentasContablesPasivo(),
        getCuentasContables(),
        getIPEJALtasas(),
        getEstadosGlobales(),
      ]);
      if (mounted) {
        setData(_data);
        const normalized = normalize(_cuentasContables);
        setCuentasContables(normalized);
        setCatalogoDeCuentasContablesPasivo(_catalogoDeCuentasContablesPasivo);
        setEstados(_estados);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    setSelectedData({});
  };
  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    setAdding(false);
    const [key] = selectedRowKeys;
    const match = responseData || data?.find((item) => item.id === key);
    const _validacionesConfigReloj = await getIPEJALtasa(match.id);

    setTimeout(() => {
      if (_validacionesConfigReloj) {
        const formValues = {
          ...formatReceived(_validacionesConfigReloj),
          // Asigna el ID del estado global
          // Convierte la fecha de vigencia final a objeto moment si existe, si no null
          vigencia_final: _validacionesConfigReloj.vigencia_final
            ? moment(_validacionesConfigReloj.vigencia_final)
            : null,
        };
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(formValues));
          setDisableFields(_validacionesConfigReloj?.estados_globales !== ESTATUS_ACTIVO);
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };
  const onClickAdd = () => {
    setAdding(true);
    form.resetFields();
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const onFinish = async (_continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();

      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;

      if (values.vigencia_final?.format) {
        values.vigencia_final = values.vigencia_final.format('YYYY-MM-DD');
      }
      const saved = await (key ? patchIPEJALtasa(key, values) : postIPEJALtasa(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteIPEJALtasa(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });

    const dataForForm = {
      ...record,
      vigencia_final: record.vigencia_final
        ? moment(record.vigencia_final)
        : null,
    };

    form.setFieldsValue(dataForForm);
  };
  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };
  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar un Incidencia Validacion ya autorizado');
        return;
      }
      const saved = await autorizarIPEJALtasa(key);
      if (saved) {
        const _data = await getIPEJALtasas();
        setData(formatReceived(_data));
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Concepto',
      dataIndex: 'concepto',
      key: 'concepto',
      width: 200,
    },
    {
      titleText: 'Tasa',
      dataIndex: 'tasa',
      key: 'tasa',
      width: 200,
      align: 'right',
      render: (val) => percentFormatter(val || 0),
    },
    {
      titleText: 'Vigencia Final',
      dataIndex: 'vigencia_final',
      key: 'vigencia_final',
      width: 150,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 180,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    porcentaje: [
      requiredRule,
      {
        pattern: FLOAT_NUMER_PATTERN,
        message: 'Ingrese un valor válido',
      },
      {
        validator: async () => {
          const { porcentaje } = form.getFieldValue();
          if (porcentaje > 100) {
            throw new Error('Este campo no puede ser mayor a 100%');
          }
        },
      },
    ],
  };

  return (
    <Row align="center" justify="center" className="container">
      <Col span={24}>
        <Spin tip="Cargando..." spinning={loading}>
          {!open ? (
            <Table
              cols={columns}
              data={data}
              rowSelection={rowSelection}
              handleOnRowClick={handleOnRowClick}
              controls={{
                onClickAdd,
                onClickEdit: () => onClickEdit(),
                onClickDelete,
              }}
              customActions={[
                {
                  onClick: () => setVisibleAutorizar(true),
                  permission: { model: 'tasaipejal', action: 'autorizar' },
                  icon: <CheckCircleOutlined />,
                  text: 'Autorizar',
                  disabledBySelection: true,
                  disabled: selectedData?.estados_globales !== ESTATUS_ACTIVO,
                  className: 'success',
                },
              ]}
              disableDelete={selectedData?.estados_globales !== ESTATUS_ACTIVO}
              permission={permission}
              allowExportParam={false}
              allowSearch={false}
            />
          )
            : (
              <Card
                className="form-container"
                title="Revisar Reporte Del Reloj Checador"
                extra={(
                  <FormSubmitControls
                    onCancel={onCancel}
                    loading={loading}
                    onFinish={onFinish}
                    onFinishText="Guardar y Continuar"
                  />
                )}
                bordered={false}
              >
                <Form
                  layout="vertical"
                  form={form}
                  onFinish={onFinish}
                  scrollToFirstErrorDatePicker
                  name="Validacion"
                  initialValues={{
                    estados_globales: ESTATUS_ACTIVO,
                  }}
                >
                  <Row gutter={10}>
                    <Col xs={24} sm={8}>
                      <Form.Item
                        name="concepto"
                        label="Concepto"
                        rules={rules.required}
                        hasFeedback
                      >
                        <Input
                          allowClear
                          disabled={disableFields}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={8}>
                      <PercentageInput
                        allowClear
                        name="tasa"
                        label="Tasa"
                        rules={rules.porcentaje}
                        hasFeedback
                        disabled={disableFields}
                      />
                    </Col>
                    <Col xs={24} sm={8}>
                      <Form.Item
                        name="vigencia_final"
                        label="Vigencia Final"
                        hasFeedback
                      >
                        <DatePicker
                          allowClear
                          placeholder=""
                          format="YYYY-MM-DD"
                          disabled={isAdding || selectedData?.estados_globales === ESTATUS_INACTIVO}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={8}>
                      <Form.Item
                        name="estados_globales"
                        label="Estatus"
                        hasFeedback
                      >
                        <Select
                          labelProp="descripcion"
                          keyProp="id"
                          dataSource={estados}
                          activeInactive={selectedData?.estados_globales === ESTATUS_ACTIVO}
                          disabled={selectedRowKeys.length <= 0 || disableFields}
                          onChange={(val) => setVisibleConfirmInactivo(val === ESTATUS_INACTIVO)}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Col xs={24} sm={24} md={24}>
                    <RegistroPresupuestalIPEJAL permission={permission} idFather={selectedRowKeys} />
                  </Col>
                  <Form.Item shouldUpdate>
                    {({ getFieldValue }) => {
                      const tipo = getFieldValue('catalogo_contable_del_pasivo_patronal');
                      return (
                        <Row gutter={12}>
                          <Col xs={24} sm={8}>
                            <Form.Item
                              name="catalogo_contable_del_pasivo_patronal"
                              label="Tipo de Registro Contable"
                              rules={rules.required}
                            >
                              <Select
                                labelProp="cuenta_contable"
                                keyProp="id"
                                render={(item) => `${item?.nombre}`}
                                dataSource={catalogoDecuentasContablesPasivo}
                              />
                            </Form.Item>
                          </Col>
                          {tipo === 1 && (
                            <Col xs={24} sm={8}>
                              <Form.Item
                                name="cuenta_contable_del_pasivo_empleado"
                                label="Cuenta Contable"
                                rules={[{ required: true, message: 'Selecciona una cuenta contable' }]}
                                hasFeedback
                              >
                                <TreeSelect
                                  showSearch
                                  allowClear
                                  treeNodeFilterProp="title"
                                  // treeDefaultExpandAll
                                  style={{ width: '100%' }}
                                  treeData={mapToTreeData(cuentasContables)}
                                />
                              </Form.Item>
                            </Col>
                          )}
                          {tipo === 2 && (
                            <Col xs={24} md={24}>
                              <CuentaContableIPEJAL permission={permission} idFather={selectedRowKeys} />
                            </Col>
                          )}
                        </Row>
                      );
                    }}
                  </Form.Item>
                  <Form.Item hidden>
                    <Button htmlType="submit" />
                  </Form.Item>
                </Form>
              </Card>
            )}
          <ModalDelete
            onDelete={deleteItem}
            onCancel={() => setVisibleAlert(false)}
            open={visibleAlert}
            content={`Tasa de Ipejal  ${form.getFieldValue('concepto') || ''}`}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={onConfirmAutorizar}
            ConfirmAutorize
            onCancel={() => setVisibleAutorizar(false)}
            contentTitle={`Autorizar Tasa de Ipejal  ${form.getFieldValue('concepto') || ''}`}
            open={visibleAutorizar}
            loading={loading}
          />
          <ModalConfirmation
            onFinish={() => setVisibleConfirmInactivo(false)}
            ConfirmInactive
            onCancel={() => {
              form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
              setVisibleConfirmInactivo(false);
            }}
            open={visibleConfirmInactivo}
            contentTitle={`Inactivar Tasa de Ipejal ${form.getFieldValue('concepto') || ''}`}
            loading={loading}
          />
        </Spin>
      </Col>
    </Row>
  );
};

export default TasasIPEJAL;
